export default __webpack_public_path__ + "static/media/a33fd61095036ef69c05fd5af43580e71576593296100.bc552449.webp";